module.exports = ".fuse-widget-front {\n  border-radius: 12px !important; }\n\n.titulo {\n  background-color: #0dab93;\n  color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/tickets/components/lista-adjuntos/lista-adjuntos.component.scss
// module id = ./src/app/main/content/tickets/components/lista-adjuntos/lista-adjuntos.component.scss
// module chunks = main